<template>
  <div class="modal-card ml-0" style="min-width: 76vw">
    <!-- :close="$store.commit('ui/TOGGLE_MENU', false)" -->
    <header
      class="modal-card-head has-background-white"
      style="height: 52px; padding-bottom: 0px; padding-top :0px"
    >
      <div class="level is-mobile">
        <router-link
          :to="{name: 'user-profile', params: {slug: $store.state.user.authUser.uid}}"
          class="level-item"
          v-if="$store.state.user.userDoc && !$store.state.user.userDoc.isAnonymous"
        >
          <figure class="image is-rounded is-24x24" style="background-color: grey">
            <img :src="$store.state.user.authUser.photoURL" alt class="is-rounded" />
          </figure>
        </router-link>

        <router-link :to="{name: 'signin'}" class="level-item" v-else>
          <span class="icon has-text-grey-dark">
            <i class="mdi mdi-account-outline mdi-24px"></i>
          </span>
        </router-link>

        <router-link
          :to="{name: 'user-profile', params: {slug: $store.state.user.authUser.uid}}"
          class="level-item"
          v-if="$store.state.user.authUser && !$store.state.user.authUser.isAnonymous"
        >{{$t('ui.myAccount')}}</router-link>

        <div class="level-item ml-auto" v-else>
          <router-link class="has-text-weight-medium" :to="{name: 'signin'}">{{$t('auth.logIn')}}</router-link>
        </div>
      </div>
      <!-- <p class="modal-card-title is-size-18px has-text-weight-semibold">{{ $t('ui.menu') }}</p> -->
    </header>
    <section class="modal-card-body px-0 py-half">
      <aside class="menu mb-1 pl-half">
        <!-- <div class="menu-label">{{$t('ui.menu')}}</div> -->
        <ul class="menu-list">
          <!-- <hr class="mt-0"> -->
          <li class="has-text-black-ter">
            <router-link
              
              style="display: flex; align-items: center"
              @click.native="$analytics.logEvent('view_page', { page_name: $route.name, item_name: 'home', button_name: 'home_btn_on_menu'})"
              :to="{name: 'home', params: { cityName: $store.state.user.userCity }}"
              :class="{ 'has-text-black': $route.name === 'home',
               'has-text-weight-bold': $route.name === 'home'}"
            >
              <span class="icon">
                <i class="mdi mdi-home-outline mdi-24px"></i>
              </span>

              <span class="pl-1">{{$t('ui.home')}}</span>
            </router-link>
          </li>
          <li class="has-text-black-ter" v-for="(val, key) of $store.state.ui.typeIcons" :key="key">
            <router-link
              class="" style="display: flex; align-items: center"
              :class="{ 'has-text-black': $route.params.slug === key,
               'has-text-weight-bold': $route.params.slug === key}"
              :to="{name: 'events', params: {cityName: $store.state.user.userCity, slug: key }}"
              @click.native="$analytics.logEvent('view_item_list', { page_name: $route.name, item_name: key, button_name: 'type_on_menu'})"
            >
              <span class="icon ">
                <i class="mdi mdi-24px" :class="$store.state.ui.typeIcons[key].typeIcon"></i>
              </span>
              <span class="pl-1">{{ $t(`evType.${key}`) }}</span>
            </router-link>
          </li>
        </ul>
      </aside>

      <hr class="my-1" />

      <aside class="menu pl-half">
        <ul class="menu-list">
          <!-- <li class=""> -->
          <router-link
          
            class="has-text-info p-0 has-text-weight-medium"
            style="padding-left: 12px !important; display: flex; align-items: center"
            :to="{name: 'create-event-by-mail'}"
          >
            <span class="icon">
              <i class="mdi mdi-plus mdi-24px"></i>
            </span>
            <span class="pl-half">

            {{ $t('ui.addEvent') }}
            </span>
          </router-link>
          <!-- </li> -->
        </ul>
      </aside>

      <hr class="my-1" />
      <!-- v-if="false" -->
      <div
        style="width: 100%;min-width: 76vw"
        class="card mt-half has-background-link has-text-white"
      >
        <InstallPrompt></InstallPrompt>
      </div>

      <Footer class="mt-2 mb-2 px-1"></Footer>
    </section>
  </div>
</template>

<script>
import Footer from "@/components/main/Footer";
import InstallPrompt from "@/components/shared/InstallPrompt";
import { mapGetters } from "vuex";
export default {
  name: "menu-comp",
  components: {
    Footer,
    InstallPrompt
  }
  // computed: {
  //   ...mapGetters({
  //     isMenuOpen: "ui/isMenuOpen"
  //   })
  // }
};
</script>

<style lang="scss" scoped>
// $speed-slower: 300ms;
// Slide
// .slide-next-enter-active,
// .slide-next-leave-active,
// .slide-prev-enter-active,
// .slide-prev-leave-active {
//   // transition: transform $speed-slower cubic-bezier(0.785, 0.135, 0.15, 0.86);
// }
// .slide-prev-leave-to,
// .slide-next-enter {
//   transform: translate3d(-100%, 0, 0);
//   position: absolute;
//   width: 100%;
// }
// .slide-prev-enter,
// .slide-next-leave-to {
//   transform: translate3d(100%, 0, 0);
//   position: absolute;
//   width: 100%;
// }
</style>

